<label
  *ngIf="labelTextTop"
  [htmlFor]="id"
  [ngClass]="isDisabled ? 'eq-form-label-top--disabled' : ''"
>
  {{ labelTextTop }}
</label>
<div 
  class="eq-checkbox-group eq-p-2"
  [ngClass]="[labelTextRight || labelRichText ? 'eq-flex eq-flex-nowrap eq-gap-4 eq-items-center' : '', isFocused ? 'eq-border eq-border-blue-actionBlue' : '' ]"
  (focus)="isFocused = true"
  (blur)="isFocused = false"
>
  <input
    type="checkbox"
    [id]="id"
    [name]="name"
    [required]="isRequired"
    [disabled]="isDisabled"
    [ngClass]="{ 'eq-border-error': error }"
    [ngClass]="{ '!eq-border-blue-actionBlue': isFocused }"
    class="eq-form-checkbox"
    [value]="value"
    [checked]="isChecked"
    (input)="onValueChange($event.target.checked)"
  />
  <label 
    *ngIf="labelTextRight" 
    class="eq-text-body-sm-m lg:eq-text-body-sm"
    [ngClass]="[isDisabled ? '!eq-text-grey-dusty' : 'eq-text-black-natural',
      isFocused ? 'eq-text-blue-actionBlue' : ''
    ]"
  >{{labelTextRight}}</label>
  <ng-container *ngIf="labelRichText">
    <label 
      class="eq-text-body-sm-m lg:eq-text-body-sm eq-rich-content"
      [ngClass]="[isDisabled ? '!eq-text-grey-dusty' : 'eq-text-black-natural',
        isFocused ? 'eq-text-blue-actionBlue' : ''
      ]"
      *scRichText="labelRichText"
    ></label>
  </ng-container>
</div>
<small *ngIf="error" class="eq-text-sm eq-pl-2 eq-mt-2 eq-text-red-brandRed-hover">
  {{errorText}}
</small>
